import Link from 'next/link';
import { Grid, Typography, Button, List, ListItem, ListItemIcon } from '@material-ui/core';
import { Card, CardActions, CardContent } from '@material-ui/core';
import UploadIcon from '@material-ui/icons/CloudUploadSharp';
import PersonIcon from '@material-ui/icons/PersonSharp';
import TileIcon from '@material-ui/icons/FilterFramesSharp';
import ShoppingIcon from '@material-ui/icons/ShoppingBasketSharp';
import StoreIcon from '@material-ui/icons/StorefrontSharp';
import GuideIcon from '@material-ui/icons/MenuBookSharp';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { bookingUrl, scanGuideUrl, servicedUrl, lowTouchTileGuideUrl } from '../utils/linksLib';

const useStyles = makeStyles((theme) => ({
  splash: {
    width: '40em',
  },
  gradientTop: {
    height: '12px',
    background: theme.palette.primary.main,
    marginLeft: 0,
    marginRight: 0,
  },
  gradientBottom: {
    height: '40px',
    background: theme.palette.primary.main,
    marginLeft: 0,
    marginRight: 0,
  },
  helpText: {
    marginLeft: theme.spacing(1),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  navLink: {
    color: theme.palette.primary.light,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.light,
      textDecoration: 'underline',
    },
    '&:visited': {
      color: theme.palette.primary.light,
    },
  },
  playIcon: {
    marginBottom: theme.spacing(-1),
  },
  button: {
    lineHeight: '40px',
    color: '#ffffff',
    '&:hover': {
      color: '#ffffff',
      textDecoration: 'none',
    },
  },
}));

function openInNewTab(url) {
  window.open(url, '_blank');
}

export default function GetStartedSplash(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Card className={classes.splash}>
      <div className={classes.gradientTop} />
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Get started!
        </Typography>
        <Typography variant='body1' color='textSecondary'>
          Choose how to create your own digital fabrics:
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon><TileIcon /></ListItemIcon>
            <Grid container>
              <Grid item>
                <Link href='/import' className={classes.navLink} passHref>
                  Tile your PBR textures
                </Link>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <ListItemIcon><PersonIcon /></ListItemIcon>
            <Grid container>
              <Grid item>
                <Link href={bookingUrl} className={classes.navLink} passHref>
                  <a target='_blank'>
                    Book a free demo
                  </a>
                </Link>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <ListItemIcon><ShoppingIcon /></ListItemIcon>
            <Grid container>
              <Grid item>
                <Link href='/buy?p=packages' className={classes.navLink}>
                  Order a scanning starter package
                </Link>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <ListItemIcon><StoreIcon /></ListItemIcon>
            <Grid container>
              <Grid item>
                <Link href={servicedUrl} className={classes.navLink} passHref>
                  <a target='_blank'>
                    Request serviced scanning
                  </a>
                </Link>
              </Grid>
            </Grid>
          </ListItem>
        </List>
      </CardContent>
      <CardActions className={classes.gradientBottom}>
        <Button
          className={classes.button}
          size='small'
          onClick={() => openInNewTab(scanGuideUrl)}
        >
          <GuideIcon style={{ color: theme.palette.accent.main }} />
          <Typography className={classes.helpText} variant='body1'>
            Scanning guide
          </Typography>
        </Button>
        <Button
          className={classes.button}
          size='small'
          onClick={() => openInNewTab(lowTouchTileGuideUrl)}
        >
          <GuideIcon style={{ color: theme.palette.accent.main }} />
          <Typography className={classes.helpText} variant='body1'>
            Tiling guide
          </Typography>
        </Button>
        <Link href='/upload'>
          <Button
            className={classes.button}
            size='small'
          >
            <UploadIcon style={{ color: theme.palette.accent.main }} />
            <Typography className={classes.helpText} variant='body1'>
              Create
          </Typography>
          </Button>
        </Link>
        <Link href='/import'>
          <Button
            className={classes.button}
            size='small'
          >
            <UploadIcon style={{ color: theme.palette.accent.main }} />
            <Typography className={classes.helpText} variant='body1'>
              Import
          </Typography>
          </Button>
        </Link>
      </CardActions>
    </Card>
  );
}
